export default "__VITE_ASSET__BmQ6WJ9p__"